import { Outlet } from "react-router-dom";

export default function AccountDashboard() {
  return (
    <div className="act-dashboard">
      <Outlet />
    </div>
  );
}
